var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { $modal } from 'ziphy-web-shared/basic/lib/utilities/modals';
import { formatDate } from 'ziphy-web-shared/basic/utils/time';
import MediaViewerModal from '@library/media/MediaViewer.modal';
import { PostVisitsAttachment } from '@nedoShared/features/chat/components/ChatComponent/ui/ChatMessage/ChatMessageClient/ui/PostVisitsAttachments/PostVisitsAttachment';
import { resourceExtractorNew } from '@modules/_LEGACY_/fhir/extractor';
import { $psResources } from '@store';
import $livequeueConsultationsStore from '@store/livequeueConsultationsStore';
import { SystemMessage } from '../../../SystemMessage/SystemMessage';
import { ChatMessageClientBase } from '../ChatMessageClientBase/ChatMessageClientBase';
import styles from './ClientAttachmentPostVisit.module.scss';
export const ClientAttachmentPostVisit = ({ message, containerClass }) => {
    const { t } = useTranslation();
    const attachment = message.attachments.find((el) => el.type === 'post_visit_notes' || el.type === 'medication_prescription');
    const systemMessage = `${formatDate(attachment.created, 'dateFull')} ${t('label.order_completed')}`;
    const events = $livequeueConsultationsStore.documentsEvents;
    const handleClick = (subtypes) => __awaiter(void 0, void 0, void 0, function* () {
        const filtered = events.filter((e) => Array.isArray(e.subtype) && subtypes.some((s) => e.subtype.includes(s)));
        if (!filtered.length)
            return;
        const mediaItems = filtered
            .map((event) => {
            const resource = $psResources.getById(event.id);
            if (!resource)
                return null;
            const extracted = resourceExtractorNew(resource);
            const { content, asString } = extracted;
            return Object.assign(Object.assign({}, content === null || content === void 0 ? void 0 : content.attachment), { id: event.id, effectiveDate: event.effectiveDate, title: asString.typeDescription || asString.full, source: { event, resource, extractor: extracted } });
        })
            .filter(Boolean);
        if (mediaItems.length) {
            $modal.add(MediaViewerModal, { selectedIndex: 0, items: mediaItems });
        }
    });
    const getType = (type) => {
        if (!type)
            return [];
        if (type === 'post_visit_notes') {
            return ['post_visit_note_document_type'];
        }
        if (type === 'medication_prescription') {
            return ['medication_prescription_document_type'];
        }
        return [];
    };
    const displayedAttachments = (message.attachments || []).filter((attachment) => {
        const subtypes = getType(attachment.type);
        if (!subtypes.length)
            return false;
        return events.some((e) => Array.isArray(e.subtype) && subtypes.some((s) => e.subtype.includes(s)));
    });
    return (_jsxs("div", Object.assign({ className: classNames(containerClass, styles.clientAttachmentPostVisit) }, { children: [_jsxs("div", Object.assign({ className: styles.attachmentsContainer }, { children: [_jsx("div", Object.assign({ className: styles.attachments }, { children: displayedAttachments.map((attachment) => (_jsx(PostVisitsAttachment, { attachment: attachment, onAttachmentClick: handleClick, containerClass: containerClass }, attachment.id))) })), _jsx(ChatMessageClientBase, { role: 'provider', message: message, showTimestamp: false, actions: [] })] })), _jsx(SystemMessage, { message: systemMessage })] })));
};
